import { Component, Input} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ModalWrapperComponent } from '@myapp/features/widgets';
import { SharedUICheckboxComponent, SharedUiTextareaComponent, SharedUiTextInputComponent } from '@myapp/modules/forms/components';
import { BaseEditorComponent } from '../../base-editor/base-editor.component';
import { LicenseUserEditForm } from './LicenseUserEditForm';
import { NgIf, NgFor } from '@angular/common';
import { ModuleChecked, RequestModuleUserSet } from '../../../models';
import { LabelModule } from '@progress/kendo-angular-label';
import { SharedUiListviewComponent } from '../../../../../modules/forms/components/shared-ui-listview/shared-ui-listview.component';

@Component({
  selector: 'app-user-grid-editor',
  templateUrl: './user-grid-editor.component.html',
  styleUrls: ['./user-grid-editor.component.scss'],
  standalone: true,
  imports: [ModalWrapperComponent, FormsModule, SharedUiTextInputComponent, SharedUiTextareaComponent, SharedUICheckboxComponent, SharedUiListviewComponent
    , NgIf, NgFor, LabelModule, ReactiveFormsModule]
})
export class UserGridEditorComponent extends BaseEditorComponent {
  @Input() form?: LicenseUserEditForm;


  public result: any = [];
  

  public modules: ModuleChecked[] = [];

  protected users: RequestModuleUserSet = {
  }

  ngOnInit() {
    console.log(this.form);
    super.ngOnInit();

    //get modules mapped to user
    this.result = this.form?.modulesLst.filter((x: any) => x.licenseUserID != null).map((i: any) => i.id);
  }


  onCheckChange(event: Event) {
    const inputTarget = event.target as HTMLInputElement;

    const ischecked = (<HTMLInputElement>event.target).checked;

    this.form?.addControl('checkBoxChange', new FormControl(true)); //to mark 'form change' so that save button is enabled
    if (ischecked) {
      if (this.result.filter((x: any) => x.id != inputTarget.value)) {
        let val = this.form?.modulesLst.filter((x: any) => x.id == inputTarget.value).map((i: any) => i.id);
        this.result = this.result.concat(val);
      }
    }
    else {
      let val = this.result.filter((x: any) => x != inputTarget.value);
      this.result = val;
    }

    this.form!.checkedModuleIds = this.result;//selected checkboxIds being passed as form element
  }

}


